import { UserGenqlSelection } from '@rematter/frontend-lib-api-client';

export const simpleUserFragment = {
  id: true,
  firstName: true,
  lastName: true,
  email: true,
  phoneNumber: true,
  timezone: true,
  status: true,
  createdAt: true,
  updatedAt: true,
  organizations: {
    id: true,
    name: true,
  },
} satisfies UserGenqlSelection;

export const detailedUserFragment = {
  id: true,
  idpId: true,
  firstName: true,
  lastName: true,
  email: true,
  phoneNumber: true,
  timezone: true,
  status: true,
  createdAt: true,
  updatedAt: true,
  organizations: {
    id: true,
    name: true,
    domain: true,
  },
  facilities: {
    id: true,
    facilityName: true,
  },
  facilityGroups: {
    id: true,
    name: true,
  },
} satisfies UserGenqlSelection;
